'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const FlagPaAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M-3.8147e-05 0C9.33331 0 18.6667 -4.57763e-05 28 4.85778e-06V20C18.6667 20 9.33333 20 1.2517e-06 20C1.2517e-06 13.3333 0.000255184 6.66667 -3.8147e-05 0Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx("path", { d: "M28 9.33333H13.3333V0L28 4.85778e-06V9.33333Z", fill: "#E52448" }),
      /* @__PURE__ */ jsx("path", { d: "M13.3333 20H1.2517e-06V9.33333H13.3333V20Z", fill: "#1367AE" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M6.66667 5.76L5.09924 6.82405L5.62685 5.00453L4.13052 3.84262L6.02402 3.78214L6.66667 2L7.30931 3.78214L9.20282 3.84262L7.70649 5.00453L8.2341 6.82405L6.66667 5.76Z",
          fill: "#1367AE"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M20.6667 15.76L19.0992 16.824L19.6268 15.0045L18.1305 13.8426L20.024 13.7821L20.6667 12L21.3093 13.7821L23.2028 13.8426L21.7065 15.0045L22.2341 16.824L20.6667 15.76Z",
          fill: "#E52448"
        }
      )
    ]
  }
);
const VpFlagPaAsset = forwardRef(FlagPaAsset);

export { VpFlagPaAsset as default };
